<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-edit">
		<bread-crumbs
			:title="$t('Resource.Edit.EditResource')"
			:subTitle="$t('general.SubTitleResourceUpdate')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
			<span>
				{{ $t("Resource.Edit.UserNotFound.Text1") }}
				{{ $route.params.userId }}
				{{ $t("Resource.Edit.UserNotFound.Text2") }}
			</span>
			<span>
				<span>{{ $t("Resource.Edit.UserNotFound.Check") }}</span>
				<router-link :to="{name: 'page-user-list'}" class="text-inherit underline">{{
					$t("Resource.Edit.UserNotFound.AllUsers")
				}}</router-link>
			</span>
		</vs-alert>
		<div class="tab-text">
			<resource-edit-tab-account
				v-if="
					resource_data !== null &&
					resourceUpdatePermission &&
					objectRPermission &&
					typeConfigRPermission &&
					statusRPermission &&
					roleRPermission
				"
				:data="resource_data"
			/>
			<not-permission
				v-if="
					!resourceUpdatePermission ||
					!objectRPermission ||
					!typeConfigRPermission ||
					!statusRPermission ||
					!roleRPermission
				"
				:message="message"
			></not-permission>
		</div>
	</div>
</template>

<script>
import ResourceEditTabAccount from "./ResourceEditTabAccount.vue";
import NotPermission from "@/views/pages/NotPermission.vue";
// Store Module
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	components: {
		ResourceEditTabAccount,
		NotPermission,
	},
	data() {
		return {
			resource_data: null,
			user_not_found: false,
			activeTab: 0,
		};
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		fetch_resource_data(userId) {
			this.openLoading();
			const dataFilter = {
				ids: [userId],
			};
			this.$store
				.dispatch("moduleResource/fetchResourceFilterById", dataFilter)
				.then((res) => {
					this.resource_data = res.data.records[0];
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					if (err.response.status === 404) {
						this.user_not_found = true;
						return;
					}
					throw new Error(err);
				});
		},
	},
	created() {
		// Register Module Resource Module
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
	computed: {
		resourceUpdatePermission() {
			return this.$store.getters.checkPermission("RESOURCES_U");
		},
		objectRPermission() {
			return this.$store.getters.checkPermission("OBJECTS_R");
		},
		typeConfigRPermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_R");
		},
		roleRPermission() {
			return this.$store.getters.checkPermission("ROLE_R");
		},
		statusRPermission() {
			return this.$store.getters.checkPermission("STATUS_R");
		},
		message() {
			return `${this.$t(
				"Permissions.RequiredPermissions"
			)} "RESOURCES_U" , "ROLE_R", "STATUS_R", "OBJECTS_R", "TYPE_CONFIG_R"`;
		},
	},
	mounted() {
		this.fetch_resource_data(this.$route.params.userId);
	},
};
</script>
